import React, { useState, useEffect } from 'react';
import { Phone, MessageCircle, X } from 'lucide-react';
import { Button } from './ui/button';
import { companyInfo } from '../mock';

const StickyCallButton = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [isExpanded, setIsExpanded] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      // Show button after scrolling 300px
      setIsVisible(window.scrollY > 300);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleCall = () => {
    window.location.href = `tel:${companyInfo.phone}`;
  };

  const handleWhatsApp = () => {
    const phoneNumber = '491522757500';
    const message = encodeURIComponent('Hallo, ich interessiere mich für Ihre Hausmeister-Dienstleistungen.');
    window.open(`https://wa.me/${phoneNumber}?text=${message}`, '_blank');
  };

  if (!isVisible) return null;

  return (
    <>
      {/* Mobile Sticky Buttons */}
      <div className="fixed bottom-6 right-6 z-50 flex flex-col items-end space-y-3 lg:hidden">
        {isExpanded && (
          <>
            <Button
              onClick={handleWhatsApp}
              className="bg-green-600 hover:bg-green-700 text-white shadow-2xl animate-in slide-in-from-bottom-2"
              size="lg"
            >
              <MessageCircle className="w-5 h-5 mr-2" />
              WhatsApp
            </Button>
            <Button
              onClick={handleCall}
              className="bg-slate-900 hover:bg-slate-800 text-white shadow-2xl animate-in slide-in-from-bottom-2"
              size="lg"
            >
              <Phone className="w-5 h-5 mr-2" />
              Anrufen
            </Button>
          </>
        )}
        
        <Button
          onClick={() => setIsExpanded(!isExpanded)}
          className="bg-slate-900 hover:bg-slate-800 text-white shadow-2xl rounded-full w-14 h-14 p-0"
        >
          {isExpanded ? (
            <X className="w-6 h-6" />
          ) : (
            <Phone className="w-6 h-6 animate-pulse" />
          )}
        </Button>
      </div>

      {/* Desktop Sticky Bar */}
      <div className="hidden lg:block fixed bottom-0 left-0 right-0 z-50 bg-slate-900 text-white shadow-2xl animate-in slide-in-from-bottom-5">
        <div className="container mx-auto px-4 py-4">
          <div className="flex items-center justify-between">
            <div>
              <div className="text-lg font-bold">Jetzt unverbindlich anfragen!</div>
              <div className="text-slate-300 text-sm">Schnelle Terminvergabe garantiert</div>
            </div>
            <div className="flex items-center space-x-4">
              <Button
                onClick={handleWhatsApp}
                className="bg-green-600 hover:bg-green-700 text-white"
                size="lg"
              >
                <MessageCircle className="w-5 h-5 mr-2" />
                WhatsApp
              </Button>
              <Button
                onClick={handleCall}
                className="bg-white hover:bg-slate-100 text-slate-900"
                size="lg"
              >
                <Phone className="w-5 h-5 mr-2" />
                {companyInfo.phone}
              </Button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default StickyCallButton;
